import React, { ReactNode } from "react";
import { UserData, UserBooking } from "../types/responseTypes";

interface BoxTitleProps {
  children: ReactNode;
  fontSize?: string; // Optional fontSize prop, e.g., "20px", "1.5rem"
}

export const BoxTitle: React.FC<BoxTitleProps> = ({ children, fontSize }) => {
  return (
    <h1
      className="font-montserrat font-semibold text-lg text-center"
      style={{
        fontSize: fontSize || "21px", // Default to 20px if no fontSize is provided
        lineHeight: "24.38px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
};

interface BoxSubTitleProps {
  children: ReactNode;
  fontSize?: string; // Optional fontSize prop, e.g., "20px", "1.5rem"
}

export const BoxSubTitle: React.FC<BoxSubTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat text-lg text-center"
      style={{
        fontSize: fontSize || "14px", // Default to 20px if no fontSize is provided
        lineHeight: "24.38px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
};

export const LeftBoxTitle: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat font-semibold text-lg text-left"
      style={{
        fontSize: fontSize || "20px",
        lineHeight: "20px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
};

export const LeftBoxContent: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat text-lg text-left"
      style={{
        fontSize: fontSize || "20px",
        lineHeight: "20px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
};

export const LeftBoxSubTitle: React.FC<BoxSubTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat text-lg text-left"
      style={{
        fontSize: fontSize || "14px", // Default to 20px if no fontSize is provided
        lineHeight: "24.38px",
        color: "#8C8F9F",
      }}
    >
      {children}
    </h1>
  );
};

export const BannerTitle: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat font-semibold text-lg text-left"
      style={{
        fontSize: fontSize || "18px",
        lineHeight: "21.94px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
};

export const BannerSubTitle: React.FC<BoxSubTitleProps> = ({ children }) => {
  return (
    <div className="font-montserrat font-medium text-[14px] leading-[17.07px] text-left text-[#6D707E]">
      {children}
    </div>
  );
};

export const SideBarTitle: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat font-semibold text-lg text-center"
      style={{
        fontSize: fontSize || "20px",
        lineHeight: "24.38px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
};

export const SideBarBookingTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="font-montserrat font-semibold text-[16px] leading-[19.5px] text-left text-[#30323A]">
      {children}
    </div>
  );
};

export const SideBarBookingSubtitle: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div className="font-montserrat font-medium text-[14px] leading-[17.07px] text-left text-[#6D707E]">
      {children}
    </div>
  );
};

export const ProfileTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="font-montserrat font-medium text-[16px] leading-[19.5px] text-left text-[#6D707E]">
      {children}
    </div>
  );
};

export const ProfileP: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="font-montserrat font-semibold text-[16px] leading-[19.5px] text-left text-[#30323A]">
      {children}
    </div>
  );
};

export const HomeGreeting: React.FC<{
  userData: UserData;
  userBooking: UserBooking;
}> = ({ userData, userBooking }) => {
  const daysSinceBooking: number = Math.floor(
    (new Date().getTime() - new Date(userBooking.bookingCreatedAt).getTime()) /
      (1000 * 60 * 60 * 24),
  ); // ojo con esto, no sé qué se espera que sea este cálculo de acá, de momento son los días desde que se creo el booking
  return (
    <div className="flex flex-col items-center justify-center mb-10 mt-10">
      <div className="font-montserrat font-semibold text-center text-[20px] leading-[24.38px] text-[#30323A]">
        {userData.firstName}, te damos la bienvenida 👋
      </div>
      <div className="font-montserrat text-center text-[16px] leading-[19.5px] text-[#6D707E]">
        Podías estar aprovechando el sol hace {daysSinceBooking} días
      </div>
    </div>
  );
};

// Esto es una agregacion Jo permiso
interface AlignedBoxTitleProps {
  children: ReactNode;
  fontSize?: string;
}

export const AlignedBoxTitle: React.FC<AlignedBoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat font-semibold text-lg text-left"
      style={{
        fontSize: fontSize || "21px", // Tamaño de fuente por defecto
        lineHeight: "24.38px",
        color: "#30323A",
        textAlign: "left", // Alineación a la izquierda
      }}
    >
      {children}
    </h1>
  );
};

interface AlignedBoxSubTitleProps {
  children: ReactNode;
  fontSize?: string;
}

export const AlignedBoxSubTitle: React.FC<AlignedBoxSubTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h2
      className="font-montserrat text-lg text-center"
      style={{
        fontSize: fontSize || "14px", // Tamaño de fuente por defecto
        lineHeight: "24.38px",
        color: "#8C8F9F",
        textAlign: "left", // Alineación a la izquierda
      }}
    >
      {children}
    </h2>
  );
};

export const MiniCardParagraph: React.FC<AlignedBoxSubTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h2
      className="font-montserrat text-lg text-left"
      style={{
        fontSize: fontSize || "14px", // Tamaño de fuente por defecto
        lineHeight: "20px", // Aumenta el interlineado
        color: "#30323A",
        textAlign: "left", // Alineación a la izquierda
        textUnderlinePosition: "from-font",
        textDecorationSkipInk: "none",
      }}
    >
      {children}
    </h2>
  );
};

export const CenteredDegradedTitle: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (

    <h1
      className="font-montserrat font-semibold text-lg text-center"
      style={{
        fontSize: fontSize || "28px",
        lineHeight: "34.13px",
        background: "linear-gradient(90deg, #5A6ED5 0%, #64B6E5 58.5%, #EBCF4D 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        color: "transparent",
      }}
    >
      {children}
    </h1>
  );
}

export const CenteredSubTitle: React.FC<BoxSubTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat text-lg text-center"
      style={{
        fontSize: fontSize || "14px",
        lineHeight: "17.07px",
        color: "#8C8F9F",
      }}
    >
      {children}
    </h1>
  );
}

export const CenteredTitle: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat font-semibold text-lg text-center"
      style={{
        fontSize: fontSize || "24px",
        lineHeight: "29.26px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
}

export const LeftLittleTitle: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat font-semibold text-lg text-left"
      style={{
        fontSize: fontSize || "16px",
        lineHeight: "19.5px",
        color: "#30323A",
      }}
    >
      {children}
    </h1>
  );
}

export const LeftGrayContent: React.FC<BoxTitleProps> = ({
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat text-lg text-left"
      style={{
        fontSize: fontSize || "16px",
        lineHeight: "19.5px",
        color: "8C8F9F",
      }}
    >
      {children}
    </h1>
  );
}

export const LeftBlackContent: React.FC<BoxTitleProps> = ({
  
  children,
  fontSize,
}) => {
  return (
    <h1
      className="font-montserrat text-lg text-left"
      style={{
        fontSize: fontSize || "24px",
        lineHeight: "29.26px",
        color: "#515461",
      }}
    >
      {children}
    </h1>
  );
}
